import React, { Component } from 'react';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './NavMenu.scss';
import logo from '../images/CHALogoBlue.png';
import { ApplicationPaths } from './api-authorization/ApiAuthorizationConstants';
import authService from './api-authorization/AuthorizeService';

export class NavMenu extends Component {
    static displayName = NavMenu.name;

    constructor (props) {
        super(props);

        this.toggleNavbar = this.toggleNavbar.bind(this);
        this.state = {
            collapsed: true,
            userName: null,
            isAuthenticated: false,
            adminSupportEmailAddress: '',
            isAdmin: false
        };
    }

    toggleNavbar () {
        this.setState({
            collapsed: !this.state.collapsed
        });
    }

    componentDidMount() {
        this._subscription = authService.subscribe(() => this.populateState());
        this.populateState();
    }

    componentWillUnmount() {
        authService.unsubscribe(this._subscription);
    }

    async getSupport() {
        const token = await authService.getAccessToken();
        const response = await fetch('api/settings/AdminSupportEmailAddress', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        try {
            const data = await response.json();
            return data.value
        } catch (error) {
            console.error("Error fetching Admin support email address:", error);
            return "";
        } 
    }

    async populateState() {
        const [isAuthenticated, user] = await Promise.all([authService.isAuthenticated(), authService.getUser()])
        const isAdmin = user?.role === 'Admin' || (Array.isArray(user?.role) && user.role.includes('Admin'));
        this.setState({
            isAuthenticated,
            userName: user && user.name,
            isAdmin
        });
        if (isAuthenticated) {
            const adminSupportEmailAddress = await this.getSupport();
            this.setState({adminSupportEmailAddress})
        }
    }

    render() {
        const { isAuthenticated, userName, adminSupportEmailAddress, isAdmin } = this.state;
        if (!isAuthenticated) {
            const loginPath = `${ApplicationPaths.Login}`;

            return this.anonymousView(loginPath);
        } else {
            const logoutPath = `${ApplicationPaths.LogOut}`;
            return this.authenticatedView(userName, logoutPath, adminSupportEmailAddress, isAdmin);
        }        
    }

    authenticatedView(userName, logoutPath, adminSupportEmailAddress, isAdmin) {
        return (
            <nav className="navbar navbar-expand-sm border-bottom box-shadow sticky-top bg-primary text-light" >
                <div className="container">
                    <a className="navbar-brand" href="/assets">
                        <img src={logo} className="logo-img-white" alt="renu360 INSIGHT" height="36" />
                        <p className="logo-text">renu360 INSIGHT</p>
                    </a>
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse">
                        <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                            <li className="nav-item">
                                <a className="navbar-link nav-link" href="/assets"><i className="bi bi-building"></i> Assets</a>
                            </li>
                            <li className="nav-item">
                                <a className="navbar-link nav-link" href="/requirements"><i className="bi bi-clipboard2-check"></i> Requirements</a>
                            </li>
                            <li className="nav-item">
                                <a className="navbar-link nav-link" href="/recurringCosts"><i className="bi bi-calendar-event"></i> Recurring Costs</a>
                            </li>
                            <li className="nav-item">
                                <a className="navbar-link nav-link" href="/projects"><i className="bi bi-card-checklist"></i> Projects</a>
                            </li>
                        </ul>
                    </div>
                    <div className="collapse navbar-collapse">
                        <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
                            {isAdmin && (
                                <li className="nav-item">
                                    <a className="navbar-link nav-link" href="/users"><i className="bi bi-people"></i> Users</a>
                                </li>
                            )}
                            <li className={adminSupportEmailAddress ? 'nav-item' : 'd-none'} >
                                <a className="navbar-link nav-link" title="Contact Support" href={"mailto:" + adminSupportEmailAddress + "?subject=Renu360 Support Request"}><i className="bi bi-question-circle"></i></a>
                            </li>
                            <li className="nav-item">
                                <a className="navbar-link nav-link" href={logoutPath}>{userName} <i className="bi bi-box-arrow-right"></i></a>
                            </li>
                            <li className="nav-item">
                                <a className="navbar-link nav-link" href="/settings"><i className="bi bi-gear"></i></a>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
        );
    }

    anonymousView(loginPath) {
        return (
            <nav className="navbar navbar-expand-sm border-bottom box-shadow mb-3 sticky-top" style={{ background: 'white' }}>
                <div className="container">
                    <a className="navbar-brand" href={loginPath}>
                        <img src={logo} alt="Bootstrap" height="36" />
                        <p className="logo-text">renu360 INSIGHT</p>
                    </a>
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse">
                    </div>
                    <div className="collapse navbar-collapse">
                        <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                            <li className="nav-item">
                                <a className="navbar-link nav-link" href={loginPath}>Login</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
        );
    }
}
